import React from 'react';
import { Box, TextField, MenuItem } from '@mui/material';

const CustomerDetailsForm = ({
  formData,
  onChange,
  statusOptions,
  gstStatusOptions,
  gstRegTypeOptions,
  entityIdType,
  entityIdNumber,
  entityIdError,
  entityTypeOptions,
  onEntityIdTypeChange,
  onEntityIdNumberChange,
  onEntityIdBlur
}) => {
  const showGstRegistrationType = formData.gstStatus !== 'Un-Registered';
  const showEntityIdFields = [
    'Private Limited/ Public Limited',
    'LLP',
    'Registered Partnership'
  ].includes(formData.statusOfCustomer);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        select
        required
        label="Status of Customer"
        name="statusOfCustomer"
        value={formData.statusOfCustomer}
        onChange={onChange}
        fullWidth
      >
        {statusOptions.map(opt => (
          <MenuItem key={opt} value={opt}>
            {opt}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        select
        required
        label="GST Status"
        name="gstStatus"
        value={formData.gstStatus}
        onChange={onChange}
        fullWidth
      >
        {gstStatusOptions.map(opt => (
          <MenuItem key={opt} value={opt}>
            {opt}
          </MenuItem>
        ))}
      </TextField>

      {showGstRegistrationType && (
        <TextField
          select
          required
          label="GST Registration Type"
          name="gstRegistrationType"
          value={formData.gstRegistrationType}
          onChange={onChange}
          fullWidth
        >
          {gstRegTypeOptions.map(opt => (
            <MenuItem key={opt} value={opt}>
              {opt}
            </MenuItem>
          ))}
        </TextField>
      )}

      {showEntityIdFields && (
        <>
          <TextField
            select
            required
            label="Entity ID Type"
            name="entityIdType"
            value={entityIdType}
            onChange={onEntityIdTypeChange}
            fullWidth
          >
            {entityTypeOptions.map(opt => (
              <MenuItem key={opt} value={opt}>
                {opt}
              </MenuItem>
            ))}
          </TextField>
          {entityIdType && (
            <TextField
              label={`Enter ${entityIdType}`}
              required
              value={entityIdNumber}
              onChange={onEntityIdNumberChange}
              onBlur={onEntityIdBlur}
              error={Boolean(entityIdError)}
              helperText={entityIdError || ''}
              fullWidth
            />
          )}
        </>
      )}
    </Box>
  );
};

export default CustomerDetailsForm;